import { iIconProps } from '../icon';

export default function PauseIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                d='M16.95 3.25h.1c.66 0 1.24 0 1.7.06.49.07.96.22 1.35.6.38.38.53.85.6 1.35.06.46.06 1.03.06 1.7v10.1c0 .66 0 1.24-.06 1.7-.07.49-.22.96-.6 1.35-.38.38-.85.53-1.35.6-.46.06-1.03.06-1.7.06h-.1c-.66 0-1.24 0-1.7-.06-.49-.07-.96-.22-1.35-.6-.38-.38-.53-.85-.6-1.35-.06-.46-.06-1.03-.06-1.7V6.95c0-.66 0-1.24.06-1.7.07-.49.22-.96.6-1.35.38-.38.85-.53 1.35-.6.46-.06 1.03-.06 1.7-.06ZM6.95 3.25h.1c.66 0 1.24 0 1.7.06.49.07.96.22 1.35.6.38.38.53.85.6 1.35.06.46.06 1.03.06 1.7v10.1c0 .66 0 1.24-.06 1.7-.07.49-.22.96-.6 1.35-.38.38-.85.53-1.35.6-.46.06-1.03.06-1.7.06h-.1c-.66 0-1.24 0-1.7-.06-.49-.07-.96-.22-1.35-.6-.38-.38-.53-.85-.6-1.35-.06-.46-.06-1.03-.06-1.7V6.95c0-.66 0-1.24.06-1.7.07-.49.22-.96.6-1.35.38-.38.85-.53 1.35-.6.46-.06 1.03-.06 1.7-.06Z'
                fill='currentColor'
            />
        </svg>
    );
}
